module.exports = __webpack_public_path__ + "img/Estate-cars_disabled.2935ad4f.svg";